import { useNavigate } from 'react-router-dom';
import coin from "../../assets/img/icons/coin.avif";
import coupon_fallback_img from "/src/assets/img/coupon_fallback.jpg"
export default function ProductCard({product_data, onRedeem}) {
    const navigate = useNavigate();
    let productData = product_data;
   
    const handleRedeem = () => {
     navigate('/purchase',{state:productData});
    };
    return (
        <div>
            <div className="game-card">
                    <div className="game-card__box">
                    <div className="game-card__media"><img src={productData.thumb_img || coupon_fallback_img} alt={productData.title} onError={(e) => {
                                                                    e.currentTarget.onerror = null;
                                                                    e.currentTarget.src = coupon_fallback_img;
                                                                }} /></div>
                    <div className="game-card__info"><span className="game-card__title" style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", lineHeight: "1.2", minHeight: "3em" }}><small> {productData.title}</small></span>
                        {/* <div className="game-card__genre">{productData.genre}</div> */}
                        <div className="game-card__rating-and-price">
                            <div className="game-card__rating"><small>{productData.sub_title}</small></div>
                            <div className="game-card__price"><span>Price: </span><img src={coin} alt="coin icon" width="16" height="16" />&nbsp;<span>{productData.price}</span></div>
                        </div>
                        <div className="game-card__bottom">
                            <div className="game-card__platform"></div>
                            <div className="game-card__users">
                                <button className="" style={{ padding: "5px 10px", fontSize: "14px", background:'#ff810e', outline:'none', border:'none', color:'#ffffff',fontWeight:'bold',borderRadius:'4px' }} onClick={(event) => {
                                            event.preventDefault();
                                            handleRedeem();
                                }}>Redeem&nbsp;<i className="fa-solid fa-arrow-right"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
